import styled from "@emotion/styled";

export const PaymentFooterWrapper = styled.div`
  height: 92px;
`;

export const PaymentOption = styled.div`
  margin-top: 8px;
  min-height: 32px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .payment-option {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const PaymentButton = styled.div`
  min-height: 48px;
`;

export const Icon = styled.div`
  border: 1px solid ${({ theme }: any) => theme.colors.snow300};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  padding:3px;
  img {
    width: 24px;
    height: 24px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 12px;
`;

export const PaymentOptionChangeCta = styled.div`
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin-left: 4px;
  }
`;

export const UpiCollectWrapper = styled.div`
  .form-field {
    margin-bottom: 0;
  }
`;

export const UpiCollectHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const UpiCollectIcon = styled.div`
  width: 56px;
  height: 56px;
  border: 1px solid ${({ theme }: any) => theme.colors.snow300};
  border-radius: 8px;
  img {
    width: 56px;
  }
`;

export const UpiTimerScreenWrapper = styled.div`
  height: 505px;
  positon: relative;
  button {
    position: absolute;
    box-shadow: 0px 0px 4px 0px #1113141f;
    height: 56px;
    bottom: 0;
    left: 0;
    background: white;
  }
  p {
    text-align: left;
  }
`;

export const PaymentRecommendations = styled.div`
  margin-top: 30px;
  background: ${({ theme }: any) => theme.colors.info10};
  border-radius: 16px;
  .paymentMethodCartLayout {
    margin: 0;
    border-radius: 0;
    border-color: transparent;
  }
`;

export const PaymentRecommendationsHeader = styled.div`
  display: flex;
  height: 30px;
  padding: 6px 16px;
  margin-top: 69px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
`;

export const RecommendationsOption = styled.div`
  background: white;
  border: 1px solid ${({ theme }: any) => theme.colors.snow300};
  border-radius: ${({ theme }: any) => theme.borders.radiusPrimary};
  overflow: hidden;
  border-bottom: none;
  > div {
    border-bottom: 1px solid ${({ theme }: any) => theme.colors.snow300};
  }
  .form-field {
    margin-bottom: 0;
  }
  .subtitle {
    display: flex;
    img{
      margin-left: 12px;
    }
  }
  .content-wrapper{
    margin-bottom: 0;
  }
  .bundle-textWrapper{
    display: none;
  }
  .accordianLayout{
    padding: 0;
  }
`;

export const OtherPaymentOptionWrapper = styled.div`
  border: 1px solid ${({ theme }: any) => theme.colors.snow300};
  border-bottom: none;
  border-radius: ${({ theme }: any) => theme.borders.radiusPrimary};
  height: auto;
  margin: 10px 0;
  overflow: hidden;
`;

export const BottomSheetRecommendationsHeader = styled.div`
  padding: 4px 20px;
  position: fixed;
  background: white;
  z-index: 2;
  width: 100%;
  left: 0;
  p{
    margin-bottom: 2px;
  }
}
`;

export const PayNowButton = styled.div`
  padding: 16px 20px;
`;

export const OtherOption = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15.5px 16px;
  border-bottom: 1px solid ${({ theme }: any) => theme.colors.snow300};
`;

export const TitelWrapper = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 12px;
  }
`;

export const RecommendationsWrapper = styled.div`
  margin-bottom: 32%;
  height: calc(100% - 80px);
  overflow: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar-track {
    background: none;
  }
`;
